export const classes = {
  card: 'relative rounded-[26px] border border-white/80 bg-[linear-gradient(155deg,rgba(255,255,255,0.94),rgba(255,255,255,0.82))] shadow-glass backdrop-blur-[30px] dark:border-white/[0.12] dark:bg-[linear-gradient(155deg,rgba(54,49,68,0.92),rgba(40,36,52,0.86))] dark:shadow-glass-dark',
  single:
    'flex w-[432px] max-w-[calc(100vw-32px)] flex-col px-[46px] pb-9 pt-[46px]',
  split:
    'grid min-h-[520px] w-[1060px] max-w-[calc(100vw-32px)] grid-cols-[430px_1fr] overflow-hidden',
  splitTall:
    'grid w-[1060px] max-w-[calc(100vw-32px)] h-[632px] grid-cols-[430px_1fr] overflow-hidden',
  splitStart:
    'grid w-[1060px] max-w-[calc(100vw-32px)] h-[742px] grid-cols-[430px_1fr] overflow-hidden',
};

export const styles = {
  card: { animation: 'card-in 0.32s cubic-bezier(0.22, 1, 0.36, 1)' },
};
